<div class="delete-container mct-flex mct-col mct-justify-center mct-items-center"   [wl-busy-overlay]="deleting" [busyCenter]="true">
  <div>
    <button pButton type="button" [disabled]="invoice?.InvoiceHeader.Posted" class="atlas-btn atlas-btn-danger" type="button" (click)="deleteInvoice(invoice)">
      {{ 'invoices.invoice-builder.delete-tab.delete-button' | translate | uppercase }}
    </button>
  </div>
  <div *ngIf="invoice?.InvoiceHeader.Posted">
    {{'invoices.invoice-builder.delete-tab.cannot-delete-message' | translate}}
  </div>
</div>

<p-confirmDialog
  #cd
  key="deleteInvoice"
  header="{{ 'invoices.invoice-builder.delete-tab.delete-confirm-header' | translate }}"
>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" (click)="cd.onReject()">{{ 'common.cancel' | translate | uppercase }}</button>
    <button pButton type="button" class="atlas-btn atlas-btn-danger" (click)="cd.onAccept()">
      {{ 'invoices.invoice-builder.delete-tab.delete-button' | translate | uppercase }}
    </button>
  </ng-template>
</p-confirmDialog>
